let apiUrl = "";
if(process.env.NODE_ENV === "renewal"){
    apiUrl = 'https://renewal-api.tablenjoy.com:30081';
}else{
    apiUrl = 'https://test-api.tablenjoy.com:30080'; //apiUrl = 'https://test-api.tablenjoy.com:30080';
}


module.exports = {
  basicURL:
    process.env.NODE_ENV === "production"
      ? "https://api.tablenjoy.com"
      : `${apiUrl}`,
  testURL: "http://10.1.1.200:8080",

  auth: {
    register: "/users/v1/{site_name}/admin/auth/register",
    login: "/users/v1/{site_name}/admin/auth/login",
    refresh: "/users/v1/{site_name}/admin/auth/refresh",
    logout: "/users/v1/{site_name}/admin/logout",
    myInfo: "/users/v1/{site_name}/admin/myInfo",
  },
  goods: {
    page: "/goods/v1/{site_name}/mng/goods/manage/adm/page", // 상품 리스트 조회
    intro: "/goods/v1/{site_name}/mng/goods/manage/adm/intro/query", // 상품 소개 정보 조회 (Manager)
    options: "/goods/v1/{site_name}/mng/goods/manage/adm/options/query", // 상품 옵션 조회 (Manager)
    condition: "/goods/v1/{site_name}/mng/goods/manage/adm/condition/query", // 상품 사용 조건 조회 (Manager)
    optionsAndUsableHours:
      "/goods/v1/{site_name}/mng/goods/manage/adm/optionsAndUsableHours/query", // 상품 옵션 및 이용 가능 시간 조회 (Manager)
    channels: "/goods/v1/{site_name}/mng/goods/manage/adm/channels/query", // 상품 B2B 채널 배포 설정 조회 (Manager)
    usage: "/goods/v1/{site_name}/mng/goods/manage/adm/usage/query", // 상품 사용 정보 조회 (Manager)
    notice: "/goods/v1/{site_name}/mng/goods/manage/adm/notice/query", // 상품 고시 정보 및 기타 설정 조회 (Manager)
    usableHours: "/goods/v1/{site_name}/mng/goods/manage/adm/usableHours/query", // 상품 이용 가능 시간 조회 (Manager)
    stopSales: "/goods/v1/{site_name}/mng/goods/operation/adm/goods/stopSales", // 상품 판매 중지 (Manager)
    resumeSales:
      "/goods/v1/{site_name}/mng/goods/operation/adm/goods/resumeSales", // 상품 판매 재개 (Manager)
    updateMainOption:
      "/goods/v1/{site_name}/mng/goods/operation/adm/options/mainOption/update", // 메인 옵션 변경 (Manager)
    optionsStopSales:
      "/goods/v1/{site_name}/mng/goods/operation/adm/options/stopSales", // 옵션 판매 중지 (Manager)
    optionsResumeSales:
      "/goods/v1/{site_name}/mng/goods/operation/adm/options/resumeSales", // 옵션 판매 재개 (Manager)
    create: "/goods/v1/{site_name}/mng/goods/register/adm/draft/create", // 등록 대기 상품 정보 생성  (BRD)
    registerPage: "/goods/v1/{site_name}/mng/goods/register/adm/page", // 등록 대기 상품 리스트 조회  (BRD)
    requestedPage:
      "/goods/v1/{site_name}/mng/goods/register/adm/requested/page", // 등록 승인 요청 상품 리스트 조회 (BRD, TNJ)
    info: "/goods/v1/{site_name}/mng/goods/register/adm/get", // 등록 대기 상품 정보 조회  (BRD)
    update: "/goods/v1/{site_name}/mng/goods/register/adm/draft/update", // 등록 대기 상품 정보 수정  (BRD)
    request: "/goods/v1/{site_name}/mng/goods/register/brd/request", // 등록 대기 상품 등록 요청  (BRD)
    updateIntro: "/goods/v1/{site_name}/mng/goods/manage/adm/intro/update", //상품 소개 정보 변경 (Manager)
    updateCondition:
      "/goods/v1/{site_name}/mng/goods/manage/adm/condition/update", //상품 사용 조건 변경 (Manager)
    updateOptions: "/goods/v1/{site_name}/mng/goods/manage/adm/options/update", //상품 옵션 정보 변경 (Manager)
    updateUsableHours:
      "/goods/v1/{site_name}/mng/goods/manage/adm/usableHours/update", //상품 이용 가능 시간 변경 (Manager)
    updateOptionsAndUsableHours:
      "/goods/v1/{site_name}/mng/goods/manage/adm/optionsAndUsableHours/update", //상품 옵션 및 이용 가능 시간 변경 (Manager)
    updateChannels:
      "/goods/v1/{site_name}/mng/goods/manage/adm/channels/update", //상품 B2B 채널 배포 설정 변경 (Manager)
    updateUsage: "/goods/v1/{site_name}/mng/goods/manage/adm/usage/update", //상품 사용 정보 변경 (Manager)
    updateNotice: "/goods/v1/{site_name}/mng/goods/manage/adm/notice/update", //상품 고시 정보 및 기타 설정 변경 (Manager)
    deleteGoods: "/goods/v1/{site_name}/mng/goods/manage/adm/goods/delete", //상품 삭제 (Manager)
    deleteReqGoods: "/goods/v1/{site_name}/mng/goods/register/adm/draft/delete", //등록 대기 상품 정보 삭제 (BRAND, TNJ)
    cancelRequest: "/goods/v1/{site_name}/mng/goods/register/brd/cancelRequest", //등록 대기 상품 등록 요청 취소 (BRAND, TNJ)
  },
  shop: {
    // 매장 API (관리자)
    area: "/brands/v1/{site_name}/public/store/storeAreas",
    delete: "/brands/v1/{site_name}/mng/store/adm/delete", // 매장삭제 (BRAND, TNJ)
    activate: "/brands/v1/{site_name}/mng/store/adm/enable", // 매장 활성화 (BRAND, TNJ)
    deactivate: "/brands/v1/{site_name}/mng/store/adm/disable", // 매장 비활성화 (BRAND, TNJ)
    requestList:
      "/brands/v1/{site_name}/mng/store/register/brd/newStore/pending/list", // 매장 등록 요청 리스트 조회
    registerInfo:
      "/brands/v1/{site_name}/mng/store/register/adm/newStore/register/info", // 작업 중인 매장 등록 정보 조회 (BRAND, TNJ)
    draftCreate:
      "/brands/v1/{site_name}/mng/store/register/brd/newStore/draft/create", // 매장 등록 정보 임시 저장 (신규 생성) (BRAND)
    draftDelete:
      "/brands/v1/{site_name}/mng/store/register/brd/newStore/draft/delete", // 매장 등록 정보 임시 저장 삭제 (BRAND)
    update:
      "/brands/v1/{site_name}/mng/store/register/brd/newStore/draft/update", // 매장 등록 정보 임시 저장 (기존 정보 수정) (BRAND)
    create:
      "/brands/v1/{site_name}/mng/store/register/brd/newStore/register/request", // 매장 등록 요청  (BRD)
    reqCancel:
      "/brands/v1/{site_name}/mng/store/register/brd/newStore/register/cancelRequest", // 매장 등록 요청 취소 (BRAND)
    brandStoreCodeSearch:
      "/brands/v1/{site_name}/mng/store/brd/storeCodeNames/ofBrand", //브랜드 내 매장코드/매장명 리스트 검색 (BRD, STR)
    brandStoreCode: "/brands/v1/{site_name}/public/store/storeCodeNames/inSite", //사이트 내 매장코드/매장명 리스트 조회
    brandInfo: "/brands/v1/{site_name}/mng/brand/adm/brandsIdentities/bySites", //도메인 이름으로 브랜드 코드/이름 조회
    page: "/brands/v1/{site_name}/mng/store/adm/basicInfoStore/page", // 매장 리스트 조회 (Manager)
    exists: "/brands/v1/{site_name}/mng/store/brd/storeName/exists", // 매장 이름 중복 확인  (BRD)

    basicInfo: "/brands/v1/{site_name}/mng/store/brd/basicInfo/query", // 매장 기본 정보 조회 (BRD)
    basicInfoUpdate: "/brands/v1/{site_name}/mng/store/brd/basicInfo/update", // 매장 기본 정보 변경 (BRD)
    contents: "/brands/v1/{site_name}/mng/store/brd/siteContents/query", // 매장 콘텐츠 정보 조회 (BRD)
    contentsUpdate: "/brands/v1/{site_name}/mng/store/brd/siteContents/update", // 매장 콘텐츠 정보 변경 (BRD)
    businessInfo: "/brands/v1/{site_name}/mng/store/brd/runningInfo/query", // 매장 운영 정보 조회  (BRD)
    businessInfoUpdate:
      "/brands/v1/{site_name}/mng/store/brd/runningInfo/update", // 매장 운영 정보 변경  (BRD)
    bookingSettings:
      "/brands/v1/{site_name}/mng/store/brd/bookingSettings/query", // 매장 운영 예약 설정 조회  (BRD)
    bookingSettingsUpdate:
      "/brands/v1/{site_name}/mng/store/brd/bookingSettings/update", // 매장 운영 예약 설정 변경  (BRD)
    weekendSettings:
      "/brands/v1/{site_name}/mng/store/brd/weekendSettings/query", // 매장 운영 주말 설정 조회  (BRD)
    weekendSettingsUpdate:
      "/brands/v1/{site_name}/mng/store/brd/weekendSettingsUpdate", // 매장 운영 주말 설정 변경  (BRD)
    inventorySettingsList:
      "/brands/v1/{site_name}/mng/store/brd/inventorySettings/list", // 매장 예약 가능 인원 설정 리스트 조회  (BRD)
    inventorySettingsCreate:
      "/brands/v1/{site_name}/mng/store/brd/inventorySettings/create", // 매장 예약 가능 인원 설정 정보 생성  (BRD)
    inventorySettingsPriorityDelete:
      "/brands/v1/{site_name}/mng/store/brd/inventorySettings/delete", //예약 가능 인원 설정 정보 삭제 (BRD)
    inventorySettingsPriorityUpdate:
      "/brands/v1/{site_name}/mng/store/brd/inventorySettings/priority/update", //매장 예약 가능 인원 설정 우선 순위 변경  (BRD)
    inventorySettingFreeBooking:
      "/brands/v1/{site_name}/mng/store/brd/freeBooking/inventory/query", // 수기예약가능인원조회
    inventorySettingFreeBookingList:
      "/brands/v1/{site_name}/mng/store/brd/freeBooking/inventory/list", //기간전화예약 가능인원조회

    basicInfoStr: "/brands/v1/{site_name}/mng/store/str/basicInfo/query", // 매장 기본 정보 조회 (STR)
    basicInfoUpdateStr: "/brands/v1/{site_name}/mng/store/str/basicInfo/update", // 매장 기본 정보 변경 (STR)
    contentsStr: "/brands/v1/{site_name}/mng/store/str/siteContents/query", // 매장 콘텐츠 정보 조회  (STR)
    contentsUpdateStr:
      "/brands/v1/{site_name}/mng/store/str/siteContents/update", // 매장 콘텐츠 정보 변경  (STR)
    businessInfoStr: "/brands/v1/{site_name}/mng/store/str/runningInfo/query", // 매장 운영 정보 조회   (STR)
    businessInfoUpdateStr:
      "/brands/v1/{site_name}/mng/store/str/runningInfo/update", // 매장 운영 정보 변경   (STR)
    bookingSettingsStr:
      "/brands/v1/{site_name}/mng/store/str/bookingSettings/query", // 매장 운영 예약 설정 조회   (STR)
    bookingSettingsUpdateStr:
      "/brands/v1/{site_name}/mng/store/str/bookingSettings/update", // 매장 운영 예약 설정 변경   (STR)
    weekendSettingsStr:
      "/brands/v1/{site_name}/mng/store/str/weekendSettings/query", // 매장 운영 주말 설정 조회   (STR)
    weekendSettingsUpdateStr:
      "/brands/v1/{site_name}/mng/store/str/weekendSettingsUpdate", // 매장 운영 주말 설정 변경   (STR)
    inventorySettingsListStr:
      "/brands/v1/{site_name}/mng/store/str/inventorySettings/list", // 매장 예약 가능 인원 설정 리스트 조회  (STR)
    inventorySettingsCreateStr:
      "/brands/v1/{site_name}/mng/store/str/inventorySettings/create", // 매장 예약 가능 인원 설정 정보 생성  (STR)
    inventorySettingsPriorityDeleteStr:
      "/brands/v1/{site_name}/mng/store/str/inventorySettings/delete", //예약 가능 인원 설정 정보 삭제 (STR)
    inventorySettingsPriorityUpdateStr:
      "/brands/v1/{site_name}/mng/store/str/inventorySettings/priority/update", //매장 예약 가능 인원 설정 우선 순위 변경  (STR)
    inventorySettingFreeBookingStr:
      "/brands/v1/{site_name}/mng/store/str/freeBooking/inventory/query", //수기예약가능인원조회(STR)
    inventorySettingFreeBookingListStr:
      "/brands/v1/{site_name}/mng/store/str/freeBooking/inventory/list", //기간전화예약 가능인원조회(STR)

    inventorySettings:
      "/brands/v1/{site_name}/mng/store/brd/inventorySettings/query", // 매장 예약 가능 인원 설정 조회 (BRD, STR)
    inventorySettingsUpdate:
      "/brands/v1/{site_name}/mng/store/brd/inventorySettings/update", // 매장 예약 가능 인원 설정 정보 변경  (BRD, STR)

    bookingStatusMonthly:
      "/brands/v1/{site_name}/mng/store/tnj/booking/status/monthly", // 예약 현황 조회 (월별)
    bookingStatusWeekly:
      "/brands/v1/{site_name}/mng/store/tnj/booking/status/weekly", // 예약 현황 조회 (주별)
    bookingStatusDaily:
      "/brands/v1/{site_name}/mng/store/tnj/booking/status/daily", // 예약 현황 조회 (일별)
    bookingDateStop: "/brands/v1/{site_name}/mng/store/tnj/booking/date/stop", // 예약 중지 (특정일)
    bookingDateResume:
      "/brands/v1/{site_name}/mng/store/tnj/booking/date/resume", // 예약 재개 (특정일)
    bookingTimeSlotStop:
      "/brands/v1/{site_name}/mng/store/tnj/booking/timeSlot/stop", // 예약 중지 (특정 시간대)
    bookingTimeSlotResume:
      "/brands/v1/{site_name}/mng/store/tnj/booking/timeSlot/resume", // 예약 재개 (특정 시간대)

    storeImgListBrd: "/brands/v1/{site_name}/mng/store/brd/images/list", //매장 상세이미지 리스트 조회 API (BRD)
    storeImgListStr: "/brands/v1/{site_name}/mng/store/str/images/list", //매장 상세이미지 리스트 조회 API (STR)
    storeImgUpdateBrd: "/brands/v1/{site_name}/mng/store/brd/images/update", //매장 상세이미지 저장 API (BRD)
    storeImgUpdateStr: "/brands/v1/{site_name}/mng/store/str/images/update", //매장 상세이미지 저장 API (STR)
    storeImgTitleExistBrd:
      "/brands/v1/{site_name}/mng/store/brd/images/titleExist", //매장 상세이미지 저장 API (BRD)
    storeImgTitleExistStr:
      "/brands/v1/{site_name}/mng/store/str/images/titleExist", //매장 상세이미지 저장 API (STR)

    storeMenuListStr: "/brands/v1/{site_name}/mng/store/str/menu/list",
    storeMenuListBrd: "/brands/v1/{site_name}/mng/store/brd/menu/list",
    storeMenuDeleteStr: "/brands/v1/{site_name}/mng/store/str/menu/delete", //메뉴관리 삭제 API (STR)
    storeMenuDeleteBrd: "/brands/v1/{site_name}/mng/store/brd/menu/delete", //메뉴관리 삭제 API (BRD)
    storeMenuEnableStr: "/brands/v1/{site_name}/mng/store/str/menu/enable", //대표메뉴 온오프 활성화 API (STR)
    storeMenuEnableBrd: "/brands/v1/{site_name}/mng/store/brd/menu/enable", //대표메뉴 온오프 활성화 API (BRD)
    storeMenuDisableStr: "/brands/v1/{site_name}/mng/store/str/menu/disable", //대표메뉴 온오프 비활성화 API (STR)
    storeMenuDisableBrd: "/brands/v1/{site_name}/mng/store/brd/menu/disable", //대표메뉴 온오프 비활성화 API (BRD)

    storeMenuQueryStr: "/brands/v1/{site_name}/mng/store/str/menu/query", //메뉴관리 조회 API (STR)
    storeMenuQueryBrd: "/brands/v1/{site_name}/mng/store/brd/menu/query", //메뉴관리 조회 API (brd)
    storeMenuCreateSrt: "/brands/v1/{site_name}/mng/store/str/menu/create", //메뉴관리 등록 API (STR)
    storeMenuCreateBrd: "/brands/v1/{site_name}/mng/store/brd/menu/create", //메뉴관리 등록 API (brd)
    storeMenuUpdateSrt: "/brands/v1/{site_name}/mng/store/str/menu/update", //메뉴관리 수정 API(srt)
    storeMenuUpdateBrd: "/brands/v1/{site_name}/mng/store/brd/menu/update", //메뉴관리 수정 API(brd)
    storeMenuNumberUpdateStr:'/brands/v1/{site_name}/mng/store/str/menu/sort/number/update',
    storeMenuNumberUpdateBrd:'/brands/v1/{site_name}/mng/store/brd/menu/sort/number/update',


    storeOptionlListBrd: "/brands/v1/{site_name}/mng/store/brd/option/list", //옵션설정 리스트 조회 API (BRD)
    storeOptionlListStr: "/brands/v1/{site_name}/mng/store/str/option/list", //옵션설정 리스트 조회 API (STR)
    storeOptionlDeleteBrd: "/brands/v1/{site_name}/mng/store/brd/goods/delete", //옵션설정 삭제 API (BRD)
    storeOptionlDeleteStr: "/brands/v1/{site_name}/mng/store/str/goods/delete", //옵션설정 삭제 API (STR)

    storeOptionlCreateBrd: "/brands/v1/{site_name}/mng/store/brd/option/create", //옵션설정 등록 API (BRD)
    storeOptionlCreateStr: "/brands/v1/{site_name}/mng/store/str/option/create", //옵션설정 등록 API (STR)
    storeOptionlUpdateBrd: "/brands/v1/{site_name}/mng/store/brd/option/update", //옵션설정 수정 API (BRD)
    storeOptionlUpdateStr: "/brands/v1/{site_name}/mng/store/str/option/update", //옵션설정 수정 API (str)
    soterOprionNumUpdateStr: '/brands/v1/{site_name}/mng/store/str/menu/goods/sort/number/update',
    soterOprionNumUpdateBrd: '/brands/v1/{site_name}/mng/store/brd/menu/goods/sort/number/update',
    storeOptionlMenuBrd: "/brands/v1/{site_name}/mng/store/brd/menu/list", //메뉴관리 리스트 조회 API (BRD)
    storeOptionlMenuStr: "/brands/v1/{site_name}/mng/store/str/menu/list", //메뉴관리 리스트 조회 API (STR)

    storeOptionlQueryBrd: "/brands/v1/{site_name}/mng/store/brd/option/query", //메뉴 옵션 조회 (BRD)
    storeOptionlQueryStr: "/brands/v1/{site_name}/mng/store/str/option/query", //메뉴 옵션 조회 (STR)

  storeTimeSettingsListBrd:
      "/brands/v1/{site_name}/mng/store/brd/timeSettings/list", //시간설정 리스트 조회 (BRD)
    storeTimeSettingsListStr:
      "/brands/v1/{site_name}/mng/store/str/timeSettings/list", //시간설정 리스트 조회 API (STR)
    storeTimeSettingCreateBrd:
      "/brands/v1/{site_name}/mng/store/brd/timeSettings/create", //시간설정 등록 API (BRD)
    storeTimeSettingCreateStr:
      "/brands/v1/{site_name}/mng/store/str/timeSettings/create", //시간설정 등록 API (STR)
    storeTimeSettingQueryBRD:
      "/brands/v1/{site_name}/mng/store/brd/timeSettings/query", //시간설정 조회 API (BRD)
    storeTimeSettingQuerySTR:
      "/brands/v1/{site_name}/mng/store/str/timeSettings/query", //시간설정 조회 API (BRD)
    storeTimeSettingUpdateBRD:
      "/brands/v1/{site_name}/mng/store/brd/timeSettings/update", //시간설정 수정 API (BRD)
    storeTimeSettingUpdateSTR:
      "/brands/v1/{site_name}/mng/store/str/timeSettings/update", //시간설정 수정 API (STR)
    storeTimeSettingDeleteBRD:
      "/brands/v1/{site_name}/mng/store/brd/timeSettings/delete", //시간설정 삭제 API (BRD)
    storeTimeSettingDeleteSTR:
      "/brands/v1/{site_name}/mng/store/str/timeSettings/delete", //시간설정 삭제 API (STR)
    storeTimeSettingResetBRD:
      "/brands/v1/{site_name}/mng/store/brd/timeSettings/reset", //시간설정 초기화 API (BRD)
    storeTimeSettingResetSTR:
      "/brands/v1/{site_name}/mng/store/str/timeSettings/reset", //시간설정 초기화 API (STR)

    storetimeOptionListBRD:
      "/brands/v1/{site_name}/mng/store/brd/timeOption/list", //옵션연결 리스트 조회 API (BRD)
    storetimeOptionListSTR:
      "/brands/v1/{site_name}/mng/store/str/timeOption/list", //옵션연결 리스트 조회 API (STR)
    storetimeOptionDeleteBRD:
      "/brands/v1/{site_name}/mng/store/brd/timeOption/delete", //옵션연결 삭제 API (BRD)
    storetimeOptionDeleteSTR:
      "/brands/v1/{site_name}/mng/store/str/timeOption/delete", //옵션연결 삭제 API (STR)
    storetimeOptionQueryBRD:
      "/brands/v1/{site_name}/mng/store/brd/timeOption/query", //옵션연결 조회 API (BRD)
    storetimeOptionQuerySTR:
      "/brands/v1/{site_name}/mng/store/str/timeOption/query", //옵션연결 조회 API (STR)
    storetimeOptionUpdateBRD:
      "/brands/v1/{site_name}/mng/store/brd/timeOption/update", //옵션연결 수정 API (BRD)
    storetimeOptionUpdateSTR:
      "/brands/v1/{site_name}/mng/store/str/timeOption/update", //옵션연결 수정 API (STR)
    storeOptionListBRD: "/brands/v1/{site_name}/mng/store/brd/option/list", //옵션 리스트 조회 API (BRD)
    storeOptionListSTR: "/brands/v1/{site_name}/mng/store/str/option/list", //옵션 리스트 조회 API (STR)

    storeSwingTimeListBRD:
      "/brands/v1/{site_name}/mng/store/brd/swingTime/list", //시간대 할인 설정 리스트 조회 API (BRD)
    storeSwingTimeListSTR:
      "/brands/v1/{site_name}/mng/store/str/swingTime/list", //시간대 할인 설정 리스트 조회 API (STR)
    storeSwingTimePriorityBRD:
      "/brands/v1/{site_name}/mng/store/brd/swingTime/priority", //시간대 할인 우선순위 변경 API (BRD)
    storeSwingTimePrioritySTR:
      "/brands/v1/{site_name}/mng/store/str/swingTime/priority", //시간대 할인 우선순위 변경 API (STR)
    storeSwingTimeDeleteBRD:
      "/brands/v1/{site_name}/mng/store/brd/swingTime/delete", //시간대 할인 삭제 API (BRD)
    storeSwingTimeDeleteSTR:
      "/brands/v1/{site_name}/mng/store/str/swingTime/delete", //시간대 할인 삭제 API (STR)
    storeSwingTimeQuery: "/brands/v1/{site_name}/mng/store/brd/swingTime/query", //시간대 할인 조회 API (BRD, STR)
    storeSwingTimeUpdate:
      "/brands/v1/{site_name}/mng/store/brd/swingTime/update", //시간대 할인 수정 API (BRD, STR)
    storeSwingTimeCreateBRD:
      "/brands/v1/{site_name}/mng/store/brd/swingTime/create", //할인설정 등록 (BRD)
    storeSwingTimeCreateSTR:
      "/brands/v1/{site_name}/mng/store/str/swingTime/create", //할인설정 등록 (STR)

    storePromotionListBRD:
      "/brands/v1/{site_name}/mng/store/brd/promotion/list", // 프로모션 리스트 조회 API (BRD)
    storePromotionListSTR:
      "/brands/v1/{site_name}/mng/store/str/promotion/list", // 프로모션 리스트 조회 API (STR)
    storePromotionPriorityBRD:
      "/brands/v1/{site_name}/mng/store/brd/promotion/priority", //프로모션 우선순위 API (BRD)
    storePromotionPrioritySTR:
      "/brands/v1/{site_name}/mng/store/str/promotion/priority", //프로모션 우선순위 API (STR)
    storePromotionDeleteBRD:
      "/brands/v1/{site_name}/mng/store/brd/promotion/delete", // 프로모션 삭제 API (BRD)
    storePromotionDeleteSTR:
      "/brands/v1/{site_name}/mng/store/str/promotion/delete", // 프로모션 삭제 API (STR)
    storePromotionEnableBRD:
      "/brands/v1/{site_name}/mng/store/brd/promotion/enable", // 프로모션 상태 활성화 API (BRD)
    storePromotionEnableSTR:
      "/brands/v1/{site_name}/mng/store/str/promotion/enable", // 프로모션 상태 활성화 API (STR)
    storePromotionDisableBRD:
      "/brands/v1/{site_name}/mng/store/brd/promotion/disable", //프로모션 상태 비활성화 API (BRD)
    storePromotionDisableSTR:
      "/brands/v1/{site_name}/mng/store/str/promotion/disable", //프로모션 상태 비활성화 API (STR)
    storePromotionQueryBRD:
      "/brands/v1/{site_name}/mng/store/brd/promotion/query", //프로모션 조회 (BRD)
    storePromotionQuerySTR:
      "/brands/v1/{site_name}/mng/store/str/promotion/query", //프로모션 조회 (STR)
    storePromotionCreateBRD:
      "/brands/v1/{site_name}/mng/store/brd/promotion/create", //프로모션 등록 (BRD)
    storePromotionCreateSTR:
      "/brands/v1/{site_name}/mng/store/str/promotion/create", //프로모션 등록 (STR)
    storePromotionUpdateBRD:
      "/brands/v1/{site_name}/mng/store/brd/promotion/update", //프로모션 수정 (BRD)
    storePromotionUpdateSTR:
      "/brands/v1/{site_name}/mng/store/str/promotion/update", //프로모션 수정 (STR)

    storeDisplayUpdateBRD:
      "/brands/v1/{site_name}/mng/store/brd/display/update", //전시관리 수정 (BRD)
    storeDisplayUpdateSTR:
      "/brands/v1/{site_name}/mng/store/str/display/update", //전시관리 수정 (STR)
    storeDisplayQueryBRD:
      "/brands/v1/{site_name}/mng/store/brd/display/query", //전시관리 조회 (BRD)
    storeDisplayQuerySTR:
      "/brands/v1/{site_name}/mng/store/str/display/query", //전시관리 조회 (STR)


    storeImageslistBRD: "/brands/v1/{site_name}/mng/store/brd/images/list", //상세이미지 리스트 조회 (BRD)
    storeImageslistSTR: "/brands/v1/{site_name}/mng/store/str/images/list", //상세이미지 리스트 조회 (STR)

    storeAmenityList: "/brands/v1/{site_name}/mng/store/tnj/amenity/list", //편의시설 리스트 조회 (TNJ, BRD, STR)
    storeType: "/brands/v1/{site_name}/public/store/storeType/list", //
    storeList:"/brands/v1/{site_name}/mng/store/brd/storeCodeNames/ofBrand", // 브랜드 하위 매장 리스트조회
    kakaoPartnerListBRD:"/brands/v1/{site_name}/mng/brand/brd/partner/list", // 파트너 리스트 BRD
    kakaoPartnerListSTR:"/brands/v1/{site_name}/mng/store/str/partner/list", // 파트너 리스트 BRD
    kakaoChennelSearch: "/brands/v1/{site_name}/mng/store/adm/kakao/channel/search",
    getPartnerBrandStoreList:"/brands/v1/{site_name}/mng/store/brd/partner/query/ofBrand",
    regKakaoReserveStore: "/brands/v1/{site_name}/mng/store/adm/partner/register",
    regKakaoReserveStoreStr:"/brands/v1/{site_name}/mng/store/str/partner/register",
    updateKakaoReserveStore: "/brands/v1/{site_name}/mng/store/adm/kakao/partner/update",
    cancelKakaoReserve: "/brands/v1/{site_name}/mng/store/adm/partner/cancel",
    getKakaoPartnerViewDetail: "/brands/v1/{site_name}/mng/store/adm/kakao/partner/detail/query",
    getKakaoCategoryList:"/brands/v1/{site_name}/mng/store/adm/kakao/category/list",
    getKakaoLinkedStoreListBRD:"/brands/v1/{site_name}/mng/store/adm/partner/query/ofPartner",
    getKakaoReserveReqInfo:"/brands/v1/{site_name}/mng/store/adm/partner/detail/query",
    getKakaoLinkedStoreListSTR:"/brands/v1/{site_name}/mng/store/str/partner/query/ofKakaoId",
    updateKakaoPartnerInfo:"/brands/v1/{site_name}/mng/store/adm/kakao/partner/update",
    getKakaoPartnerLocationInfoBRD:"/brands/v1/{site_name}/mng/store/adm/basic/kakao/info/query",
    getKakaoPartnerLocationInfoSTR:"/brands/v1/{site_name}/mng/store/str/basic/kakao/info/query",
    regKakaoLocationInfoBRD:"/brands/v1/{site_name}/mng/store/adm/kakao/store/register",
    regKakaoLocationInfoSTR:"/brands/v1/{site_name}/mng/store/str/kakao/store/register",

    kakaoStoreOptionlListBrd: "/brands/v1/{site_name}/mng/store/brd/goods/list", //예약상품 리스트 조회 (BRD)
    kakaoStoreOptionlListStr: "/brands/v1/{site_name}/mng/store/str/goods/list", //예약상품 리스트 조회 (STR)

    kakaoStoreOptionlCreateStr:"/brands/v1/{site_name}/mng/store/str/goods/create", //옵션설정 등록 API (STR)
    kakaoStoreOptionlCreateBrd:"/brands/v1/{site_name}/mng/store/brd/goods/create", //옵션설정 등록 API (brd)
    kakaoStoreOptionlUpdateStr: "/brands/v1/{site_name}/mng/store/str/goods/update", //옵션설정 수정 API (STR)
    kakaoStoreOptionlUpdateBrd: "/brands/v1/{site_name}/mng/store/brd/goods/update", //옵션설정 수정 API (Brd)

    updateKakaoGoodsAdditionalInfo: "/brands/v1/{site_name}/mng/store/adm/kakaoGoods/update", //카카오연동 상품 추가정보 수정 (BRD,STR,TNJ)
    queryKakaoSyncBRD: "/brands/v1/{site_name}/mng/store/adm/kakao/sync/notification/query", // 카카오 싱크 여부알림(BRD)
    queryKakaoSyncSTR: "/brands/v1/{site_name}/mng/store/str/kakao/sync/notification/query", // 카카오 싱크 여부알림(STR)
    updateKakaoSyncBRD:"/brands/v1/{site_name}/mng/store/adm/kakao/sync/notification/update",// 카카오 싱크 업데이트(BRD)
    updateKakaoSyncStr:"/brands/v1/{site_name}/mng/store/str/kakao/sync/notification/update",// 카카오 싱크 업데이트(str)
    kakaoStoreOptionlQueryStr: "/brands/v1/{site_name}/mng/store/str/goods/query",
    kakaoStoreOptionlQueryBrd: "/brands/v1/{site_name}/mng/store/brd/goods/query",
    kakaoStoreAdditionalQueryBrd: "/brands/v1/{site_name}/mng/store/brd/kakaoGoods/query",
    kakaoStoreAdditionalQueryStr: "/brands/v1/{site_name}/mng/store/str/kakaoGoods/query",


  },
  user: {
    // 회원 및 관리자
    list: "/users/v1/{site_name}/admin/staff/list",
    info: "/users/v1/{site_name}/admin/staff/info",
    register: "/users/v1/{site_name}/admin/auth/register", // 어드민 회원가입
    changePassword: "/users/v1/{site_name}/admin/changePassword", // 비밀번호변경
    findPassOtp: "/users/v1/{site_name}/admin/auth/findPassword/otp", //비밀번호 찾기 임시 비밀번호 요청
    findPassLogin: "/users/v1/{site_name}/admin/auth/findPassword/login", //비밀번호 찾기 임시 비밀번호 로그인
    // unregister: '/users/v1/{site_name}/admin/unregister',                                                     // 관리자 게정삭제
    unregister: "/users/v1/{site_name}/admin/staff/unregister", // 관리자 게정삭제
    // grantRole: '/users/v1/{site_name}/admin/grantRole',                                                       // 관리자 권한 부여
    grantRole: "/users/v1/{site_name}/admin/brd/staff/grantRole", // 관리자 권한 부여
    azureSas: "/users/v1/{site_name}/admin/sas", //애저 토큰
    generalList: "/users/v1/{site_name}/admin/user/list/page",
    generalDetail: "/users/v1/{site_name}/admin/user/detail",
  },
  order: {
    // bookingList: '/orders/v1/{site_name}/mng/booking/adm/query/bookingList',                              //예약 리스트 조회 ( 매장 + 브랜드 )
    bookingList: "/orders/v1/{site_name}/mng/booking/adm/query/bookings/page",
    bookingListList:
      "/orders/v1/{site_name}/mng/booking/adm/query/bookings/list", //예약 리스트 조회 ( 매장 + 브랜드 )
    // bookingRequestList: '/orders/v1/{site_name}/mng/booking/adm/query/bookingRequestList',                //예약 신청 리스트 조회 ( 매장 + 브랜드 )
    bookingRequestList:
      "/orders/v1/{site_name}/mng/booking/adm/query/bookingRequests/page", //예약 신청 리스트 조회 ( 매장 + 브랜드 )
    bookingDetail:
      "/orders/v1/{site_name}/mng/booking/adm/query/bookingDetails", //예약 내용 상세 조회 ( 매장 + 브랜드 )
    approveBookingRequest:
      "/orders/v1/{site_name}/mng/booking/adm/approveBookingRequest", //예약 신청 승인(매장운영자)
    rejectBookingRequest:
      "/orders/v1/{site_name}/mng/booking/adm/rejectBookingRequest", //예약 신청 거절(매장운영자)
    // cancelBooking: '/orders/v1/{site_name}/user/booking/cancel',                                   //예약취소 ( 매장 + 브랜드 )
    noShow: "/orders/v1/{site_name}/mng/booking/adm/noShow", //예약 노쇼 처리
    cancelNoShow: "/orders/v1/{site_name}/mng/booking/adm/cancelNoShow", //예약 노쇼 처리 취소
    visitStore: "/orders/v1/{site_name}/mng/booking/adm/visitStore", //예약방문처리 ( 매장운영자)
    storeVisitInfo:
      "/orders/v1/{site_name}/mng/booking/adm/query/storeVisitInfo", //예약 방문 처리 내역 조회 ( 매장 + 브랜드 )
    cancelVisitStore: "/orders/v1/{site_name}/mng/booking/adm/cancelVisitStore", //예약 방문처리 취소 ( 매장운영자)
    // orderList: '/orders/v1/{site_name}/mng/order/adm/query/orderList',                                    // 주문내역조회 ( 매장 + 브랜드 )
    orderList: "/orders/v1/{site_name}/mng/order/adm/query/orders/page", // 주문내역조회 ( 매장 + 브랜드 )
    orderDetails: "/orders/v1/{site_name}/mng/order/adm/query/orderDetails", // 주문상세 조회( 매장 + 브랜드 )
    extendExpiryDate: "/orders/v1/{site_name}/mng/order/adm/extendExpiryDate", // 유효기간연장 ( 매장 + 브랜드 )
    cancelOrder: "/orders/v1/{site_name}/mng/order/brd/requestRefund", // 주문 취소 (BRAND)
    saveMemo: "/orders/v1/{site_name}/mng/booking/adm/saveMemo", // 예약관련메모 저장
    orderSaveMemo: "/orders/v1/{site_name}/mng/order/adm/saveMemo", // 주문관련메모 저장
    freeBookingsListStr:
      "/orders/v1/{site_name}/mng/booking/str/query/freeBookings/list", //수기예약내역조회(STR)
    freeBookingsList:
      "/orders/v1/{site_name}/mng/booking/brd/query/freeBookings/list", //수기예약내역조회(Brand)
    createFreeBookingStr:
      "/orders/v1/{site_name}/mng/booking/str/createFreeBooking",
    createFreeBooking:
      "/orders/v1/{site_name}/mng/booking/brd/createFreeBooking",
    updateFreeBooking:
      "/orders/v1/{site_name}/mng/booking/adm/updateFreeBooking",
    refundAmount: "/orders/v1/{site_name}/mng/booking/adm/query/refundAmount", //예약취소 방법/금액 조회 API
    brdcancelBooking: "/orders/v1/{site_name}/mng/booking/brd/cancelBooking", //예약 취소 (BRD, STR)
    noShowRefundAmount:
      "/orders/v1/{site_name}/mng/booking/adm/query/noShowRefundAmount",
    noShowbrd: "/orders/v1/{site_name}/mng/booking/brd/noShow",
    reserveSummary:
      "/orders/v1/{site_name}/mng/booking/adm/query/bookings/reserveSummary",
  },
  coupon: {
    couponList: "/orders/v1/{site_name}/mng/order/brd/item/query/couponList", // 모바일쿠폰, 금액권 쿠폰 조회
    consumeMobileCoupons:
      "/orders/v1/{site_name}/mng/order/adm/item/consumeMobileCoupons", // 모바일쿠폰 사용처리
    consumeBookingCoupons:
      "/orders/v1/{site_name}/mng/order/str/item/consumeBookingCoupons", // 예약권 사용처리
    useMoneyCoupon: "/orders/v1/{site_name}/mng/order/adm/pc/item/useMoneyCoupon", // 금액권 사용처리
    moneyCouponAmount:
      "/orders/v1/{site_name}/mng/order/adm/item/query/moneyCouponAmount", // 금액권 사용 가능 금액 조회
    cancelItemUseTransaction:
      "/orders/v1/{site_name}/mng/order/adm/item/cancelItemUseTransaction", // 모바일 쿠폰, 금액권 사용처리 취소
    itemUseInfo: "/orders/v1/{site_name}/mng/order/adm/item/query/itemUseInfo", // 모바일 쿠폰, 금액권 사용처리 내용 조회
    itemsUseInfo:
      "/orders/v1/{site_name}/mng/order/adm/item/query/itemsUseInfo", // 모바일 쿠폰, 금액권 리스트 사용처리 내용 조회
    reissueItems: "/orders/v1/{site_name}/mng/order/adm/item/reissueItems", // 모바일 쿠폰, 금액권 재발급
  },
  sales: {
    saleaAmounts:
    "/orders/v1/{site_name}/mng/sales/brd/totalizePurchasedSales/byBrand/daily", //판매내역 집계 (BRD)
    saleaAmountsStr:
    "/orders/v1/{site_name}/mng/sales/str/totalizePurchasedSales/byBrand/daily", //판매내역 집계 (STR)
    settlements:
      "/orders/v1/{site_name}/mng/settlement/brd/stores/settlements/totalize", //정산 금액 집계 (BRD)
    settlementsStr:
      "/orders/v1/{site_name}/mng/settlement/brd/store/settlements/totalize", //정산 금액 집계 (STR)
    completedSettlements:
      "/orders/v1/{site_name}/mng/settlement/brd/stores/completedSettlements/query", //정산완료(입금완료) 내역 조회 (BRD)
    completedSettlementsStr:
      "/orders/v1/{site_name}/mng/settlement/str/stores/completedSettlements/query", //정산완료(입금완료) 내역 조회 (STR)
  },
  statistics: {
    completedSettlementsReport:
      "/orders/v1/{site_name}/mng/settlement/brd/stores/completedSettlements/statistics/query", //브랜드 월별 정산내역 통계
    completedSettlementsReportStr:
      "/orders/v1/{site_name}/mng/settlement/str/stores/completedSettlements/statistics/query", //매장 월별 정산내역 통계
  },
  b2b: {
    channelList: "/b2b/v1/{site_name}/public/channelList", //B2B 공용 API (Public)
  },
  border: {
    borderList: "/board/v1/{site_name}/mng/board/noticeAdminBoard/query/page",
    borderPopup: "/board/v1/{site_name}/mng/board/noticeAdminBoard/popUp",
    borderDetaile:
      "/board/v1/{site_name}/mng/board/noticeAdminBoard/query/detail",
  },
  siteSet: {
    siteInfoUpdate: "/brands/v1/{site_name}/mng/brand/brd/siteInfo/update",
    siteColorUpdate: "/brands/v1/{site_name}/mng/brand/brd/siteColor/update",
    siteQuery: "/brands/v1/{site_name}/mng/brand/brd/siteInfo/query",
    siteColorQuery: "/brands/v1/{site_name}/mng/brand/brd/siteColor/query",
    siteImageUpdate: "/brands/v1/{site_name}/mng/brand/brd/siteImages/update",
    siteImageQuery: "/brands/v1/{site_name}/mng/brand/brd/siteImages/query",
    siteInfoData: "/brands/v1/{site_name}/public/brand/site/info",
    siteGiftMessageQuery: "/brands/v1/{site_name}/mng/brand/brd/giftMessage/query",
    siteGiftMessageUpdate: "/brands/v1/{site_name}/mng/brand/brd/giftMessage/update",
  },
  alimtalkMng: {
    getBrandInfo: "/brands/v1/{site_name}/public/brand/site/info",
    getStoreInfo:"/brands/v1/{site_name}/public/store/info",
    getBrandalimtalkInfo: "/brands/v1/{site_name}/mng/brand/brd/siteAlimtalk/query",
    getBrandStoreList:"/brands/v1/{site_name}/mng/store/brd/alimtalk/infoList/ofBrand",
    regBrandAlimtalk: "/brands/v1/{site_name}/mng/brand/brd/siteAlimtalk/register", //브랜드 알림톡 등록신청(BRD)
    regBrandStoreAlimtalk : "/brands/v1/{site_name}/mng/store/brd/siteAlimtalk/register",//브랜드 매장 알림톡 등록신청(BRD)
    regStoreAlimtalk: "/brands/v1/{site_name}/mng/store/str/siteAlimtalk/register", //매장 알림톡 등록신청(STR)
    requestOtp: "/brands/v1/{site_name}/public/brand/alimtalk/otpRequest",
    getStoreAlimtalk:"/brands/v1/{site_name}/mng/store/str/siteAlimtalk/query",
    brandStoresAlimtalkStop:"/brands/v1/{site_name}/mng/store/brd/siteAlimtalk/disable",
    brandAlimtalkDisable:"/brands/v1/{site_name}/mng/brand/brd/siteAlimtalk/disable",
    storeAlimtalkDisable : "/brands/v1/{site_name}/mng/store/str/siteAlimtalk/disable",
    alimtalkLargeForm:"/brands/v1/{site_name}/public/brand/alimtalk/main/category/list",
    alimtalkMiddleForm:"/brands/v1/{site_name}/public/brand/alimtalk/middle/category/list",
    alimtalkSmallForm:"/brands/v1/{site_name}/public/brand/alimtalk/small/category/list",



  },
  message: {
    sms_history_detail_list_page:
      "/messages/v1/{site_name}/mng/message/sms_history_detail_list_page",
    sms_history_list_page:
      "/messages/v1/{site_name}/mng/message/sms_history_list_page",
    marketing_message:
      "/messages/v1/{site_name}/mng/message/query/marketing_message",
    sms_list_page: "/users/v1/{site_name}/admin/user/sms/list/page",
    bookingSmsCount: "/orders/v1/{site_name}/mng/booking/adm/bookingSmsCount",
  },
  cid: {
    fcmPush: "/push/v1/{site_name}/fcmPush/register",
    alimtalkSettings:
      "/brands/v1/{site_name}/mng/store/str/alimtalkSettings/query",
  },

  existsPage: {
    site: "/brands/v1/{site_name}/public/brand/site/exists",
  },

  changeAPI: function (keyword, url) {
    return url.replace("{site_name}", keyword);
  },
};
